import React, { Component, useEffect, useState } from 'react'
import { Modal } from 'reactstrap'

import '../styles/participant.css'

import { Questions, InitialOptions } from './BaselineEvaluationConstants'
import LiverFrailtyCalculator from './LiverFrailtyCalculator'

import * as Inputs from './Inputs'
import { useHistory } from 'react-router-dom'

function pluckQuestionKeys(obj) {
  const r = {}
  Questions.forEach((q) => {
    if (obj[q.id] !== undefined) {
      r[q.id] = obj[q.id]
    }
  })
  return r
}

const BaselineEvaluationContainer = (props) => {
  const history = useHistory()

  const [state, setState] = useState({
    changes: [],
    options: InitialOptions,
    firstUnfilledIndex: 0,
  })

  useEffect(() => {
    const saved = pluckQuestionKeys(props.me.profile || {})
    if (Object.keys(saved).length) {
      onRecalculate(saved)
    }
  }, [])

  const onRecalculate = (changedState) => {
    const nextState = Object.assign({}, state, changedState, {
      options: InitialOptions,
      changes: ['Started with all options'],
    })

    let firstUnfilledIndex = Questions.findIndex(
      (q) => q.type !== 'calculated' && nextState[q.id] === undefined
    )
    if (firstUnfilledIndex === -1) {
      firstUnfilledIndex = Questions.length
    }

    nextState.firstUnfilledIndex = firstUnfilledIndex

    for (let i = 0; i < firstUnfilledIndex; i++) {
      const q = Questions[i]
      if (q.type === 'calculated') {
        nextState[q.id] = q.calculation(nextState)
      }
      if (q.transform) {
        const transformed = q.transform(nextState.options, nextState[q.id], nextState)
        if (JSON.stringify(transformed) !== JSON.stringify(nextState.options)) {
          const removed = nextState.options.filter((o) => !transformed.includes(o))
          const forced = transformed.filter((o) => !nextState.options.includes(o))

          let ex = `${q.id} answer "${nextState[q.id]}" `

          if (transformed.length === 1 && forced.length === 1) {
            ex += `forces\n - ${forced[0]}`
            nextState.changes.push(ex)
          } else if (removed.length + forced.length > 0) {
            if (removed.length) {
              ex += `removed\n - ${removed.join('\n - ')} `
            }
            if (forced.length) {
              ex += `added\n - ${forced.join('\n - ')} `
            }
            nextState.changes.push(ex)
          }

          nextState.options = transformed
        }
      }
    }

    console.log(nextState)
    setState(nextState)
  }

  const onDismissModal = () => {
    setState({ ...state, modal: undefined })
  }

  const onSubmit = () => {
    if (state.options.length === 0) {
      alert(
        'Unfortunately we were unable to automatically assign you to a fitness category. You should reach out to the EL-FIT staff so we can tailor content to your needs.'
      )
    }

    const profile = pluckQuestionKeys(state)

    props
      .onSave({
        profile: profile,
        assignedSectionName: state.options[state.options.length - 1],
      })
      .then(() => {
        history.push('/get-the-app')
      })
      .catch((err) => {
        alert(err.toString())
      })
  }
  const { options, modal, changes, firstUnfilledIndex, ...rest } = state
  const showDebugInfo = window.location.href.includes('debug')

  return (
    <div>
      <Modal isOpen={modal === 'frailty'} toggle={onDismissModal} className={props.className}>
        <LiverFrailtyCalculator
          value={state['liver-frailty-index'] || ''}
          onChange={(value) => {
            onRecalculate({ 'liver-frailty-index': value })
            onDismissModal()
          }}
        />
      </Modal>
      <div className="row">
        <div className="col-md-6 offset-md-3 p-4 shadow-lg rounded baseline-evaluation">
          <h2>Step 2/2: Complete Baseline Evaluation</h2>
          <p>
            For us to choose appropriate exercises for you over the course of the EL-FIT program, we
            need to complete a baseline evaluation. Please fill in the information below with the
            help of your physician.
          </p>
          {Questions.map((question, idx) => (
            <div key={question.id} className={`p-2 ${idx > firstUnfilledIndex ? 'grayed' : ''}`}>
              <h4>{question.text}</h4>
              {
                {
                  boolean: (
                    <Inputs.Boolean
                      {...question}
                      value={state[question.id]}
                      onChange={(value) => {
                        onRecalculate({ [question.id]: value })
                      }}
                    />
                  ),
                  number: (
                    <Inputs.Numeric
                      {...question}
                      value={state[question.id]}
                      onChange={(value) => {
                        onRecalculate({ [question.id]: value })
                      }}
                    />
                  ),
                  liverFrailty: (
                    <div>
                      <Inputs.Boolean
                        {...question}
                        value={state[question.id]}
                        onChange={(value) => {
                          onRecalculate({ [question.id]: value })
                        }}
                      />
                      {state[question.id] && (
                        <div style={{ display: 'flex', marginTop: 20 }}>
                          <input
                            className="form-control"
                            type="number"
                            placeholder="Score"
                            style={{ width: 100 }}
                            min={question.min || 0}
                            max={question.max || 100}
                            step={question.step || 1}
                            value={state[question.id]}
                            onChange={(e) => {
                              onRecalculate({ [question.id]: e.target.value })
                            }}
                          />
                          <button
                            style={{ marginLeft: 15 }}
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => setState({ modal: 'frailty' })}
                          >
                            Open LFI Calculator
                          </button>
                        </div>
                      )}
                    </div>
                  ),
                  calculated: <span />,
                }[question.type]
              }
            </div>
          ))}
          <button
            style={{ marginTop: 30, marginBottom: 30 }}
            disabled={firstUnfilledIndex !== Questions.length}
            className="btn btn-primary btn-block"
            onClick={() => onSubmit()}
          >
            Finish Baseline Evaluation
          </button>
        </div>
        {showDebugInfo && (
          <div className="col-sm-3 p-2 debug-info">
            <h4>Debug Info</h4>
            <hr />
            <h6>Remaining Choices</h6>
            <div className="p-1">
              {options.map((o) => (
                <div key={o}>{o}</div>
              ))}
            </div>
            <h6 style={{ marginTop: 20 }}>Why</h6>
            <pre className="p-1">
              {changes.map((o) => (
                <div key={o}>{o}</div>
              ))}
            </pre>

            <h6 style={{ marginTop: 20 }}>Data Collected So Far</h6>
            <pre>
              <code>{JSON.stringify(rest, null, 2)}</code>
            </pre>
          </div>
        )}
      </div>
    </div>
  )
}

export default BaselineEvaluationContainer
